export default "__VITE_PUBLIC_ASSET__e83863e8__"